import React from 'react';
import PropTypes from 'prop-types';
import BackgroundFull from '../promos/BackgroundFull';
import IpTelmexTermsForm from './IpTelmexTermsForm';

const backgroundImage =
  'url(/webclient/sk_core/images/background_iptelmex.png)';

const IpTelmexTerms = ({
  isValidForm = false,
  submitted = false,
  loading = false,
  emailValue = '',
  emailError = '',
  termsValue = 0,
  termsError = '',
  handleEmailChange = () => {},
  handleTermsChange = () => {},
  handleSubmit = () => {},
  translations = {},
  info = {},
  origin = '',
  assets = {},
}) => (
  <div>
    <BackgroundFull
      extraClassName="iptelmex"
      backgroundImage={
        assets.ip_telmex_background
          ? `url(${assets.ip_telmex_background})`
          : backgroundImage
      }
    />

    <IpTelmexTermsForm
      isValidForm={isValidForm}
      submitted={submitted}
      loading={loading}
      emailValue={emailValue}
      emailError={emailError}
      termsValue={termsValue}
      termsError={termsError}
      handleEmailChange={handleEmailChange}
      handleTermsChange={handleTermsChange}
      handleSubmit={handleSubmit}
      translations={translations}
      info={info}
      origin={origin}
    />
  </div>
);

IpTelmexTerms.propTypes = {
  isValidForm: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
  emailValue: PropTypes.string.isRequired,
  emailError: PropTypes.string.isRequired,
  termsValue: PropTypes.number.isRequired,
  termsError: PropTypes.string.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  handleTermsChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  info: PropTypes.object.isRequired,
};

export default IpTelmexTerms;
